module.exports = __webpack_public_path__ + "static/media/icon-jpg.1b09cbb8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon-jpg.svg
// module id = 521
// module chunks = 0